const documentCache = new Map();

function normalizeLocale(locale) {
  const value = String(locale || 'en').trim();
  return value || 'en';
}

function normalizeSlug(slug) {
  return String(slug || '').trim().replace(/^\/+|\/+$/g, '');
}

async function fetchMarkdownDocument(path) {
  const response = await fetch(path);
  if (!response.ok) {
    throw new Error('not found');
  }

  const contentType = response.headers.get('content-type') || '';
  if (contentType.includes('text/html')) {
    throw new Error('not found');
  }

  return response.text();
}

function createWikiDocumentResult(markdown, isFallback) {
  return {
    markdown,
    isFallback,
    hasContent: Boolean(markdown),
  };
}

export function getWikiDocumentPath({ locale, slug }) {
  const normalizedLocale = normalizeLocale(locale);
  const normalizedSlug = normalizeSlug(slug);

  return `/help/${normalizedLocale}/wiki/${normalizedSlug}.md`;
}

export async function loadWikiDocument({ locale, slug }) {
  const normalizedLocale = normalizeLocale(locale);
  const normalizedSlug = normalizeSlug(slug);

  if (!normalizedSlug) {
    return createWikiDocumentResult('', false);
  }

  const key = `${normalizedLocale}:${normalizedSlug}`;
  if (documentCache.has(key)) {
    return documentCache.get(key);
  }

  try {
    const markdown = await fetchMarkdownDocument(
      getWikiDocumentPath({ locale: normalizedLocale, slug: normalizedSlug }),
    );
    const result = createWikiDocumentResult(markdown, false);
    documentCache.set(key, result);
    return result;
  } catch {
    if (normalizedLocale === 'en') {
      const result = createWikiDocumentResult('', false);
      documentCache.set(key, result);
      return result;
    }

    try {
      const markdown = await fetchMarkdownDocument(
        getWikiDocumentPath({ locale: 'en', slug: normalizedSlug }),
      );
      const fallback = createWikiDocumentResult(markdown, false);
      const result = createWikiDocumentResult(markdown, Boolean(markdown));
      documentCache.set(`en:${normalizedSlug}`, fallback);
      documentCache.set(key, result);
      return result;
    } catch {
      const result = createWikiDocumentResult('', false);
      documentCache.set(`en:${normalizedSlug}`, result);
      documentCache.set(key, result);
      return result;
    }
  }
}
